import React from 'react';
import PropTypes from 'prop-types';

import { Quote } from '@sm360/widget-commons-vehicle';

import OfficialTradeInModal from 'trade-in/components/OfficialTradeInModal/OfficialTradeInModal.jsx';
import 'trade-in/components/InstantEstimate/InstantEstimate.scss';

class OfficialTradeIn extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isModalOpen: false,
            tradeInVehicle: {},
        };
        this.handleClose = this.handleClose.bind(this);
    }

    handleClose() {
        this.setState({ isModalOpen: false });
    }

    render() {
        return (
            <OfficialTradeInModal
                openModal={this.state.isModalOpen}
                onClose={this.handleClose}
                tradeInVehicle={this.state.tradeInVehicle}
                quote={this.props.quote}
            />
        );
    }
}

OfficialTradeIn.defaultProps = {
    quote: null,
};

OfficialTradeIn.propTypes = {
    quote: PropTypes.instanceOf(Quote.QuoteModel),
};

OfficialTradeIn.displayName = 'OfficialTradeIn';

export default OfficialTradeIn;



// WEBPACK FOOTER //
// ./src/components/OfficialTradeIn/OfficialTradeIn.jsx